# Require all of the config/environments files. /config.coffee controls which
# environment files will be loaded.
window.require.list().filter (module) ->
  require(module) if new RegExp("^config/environments/").test(module)

environmentName = TAPAS_ENV.name

if environmentName is 'development'
  options =
    LOG_TRANSITIONS:                false
    LOG_TRANSITIONS_INTERNAL:       false
    LOG_STACKTRACE_ON_DEPRECATION:  false
    LOG_BINDINGS:                   false
    LOG_VIEW_LOOKUPS:               false
    LOG_ACTIVE_GENERATION:          false

  # Log view render times to the console
  Ember.STRUCTURED_PROFILE = false

  Ember.Logger.debug("Running in the %c#{environmentName}%c environment", 'color: red;', '')
else
  options = {}

options.rootElement = '.application-container'

module.exports = Ember.Application.create(options)
